export const CONTENT_ROUTE = 'CONTENT_ROUTE'
export const GLOBAL_CONTENT_LOADED = 'GLOBAL_CONTENT_LOADED'
export const PAGE_CONTENT_LOADED = 'PAGE_CONTENT_LOADED'
export const PAGE_CONTENT_DISCARDED = 'PAGE_CONTENT_DISCARDED'
export const SELECT_GENDER = 'SELECT_GENDER'
export const SCREEN_RESIZE = 'SCREEN_RESIZE'
export const SCREEN_BREAKPOINT = 'SCREEN_BREAKPOINT'
export const SET_PREVIEW_TOKEN = 'SET_PREVIEW_TOKEN'
export const FLICKITY_DRAG_END = 'FLICKITY_DRAG_END'


export const setPreviewToken = (token) => {
    return {type: SET_PREVIEW_TOKEN, payload: token}
}


export const globalContentLoaded = (globalContent) => {
    return {type: GLOBAL_CONTENT_LOADED, payload: {globalContent}}
}

export const pageContentLoaded = (content) => {
    return {type: PAGE_CONTENT_LOADED, payload: {content}}
}

export const pageContentDiscarded = (content) => {
    return {type: PAGE_CONTENT_DISCARDED, payload: {content}}
}

export const selectGender = (gender) => {
    return {type: SELECT_GENDER, payload: {gender}}
}

export function screenResize(width) {
    return {
        type: SCREEN_RESIZE,
        screenWidth: width
    };
}

export function screenBreakpoint(breakpoint) {
    return {
        type: SCREEN_BREAKPOINT,
        breakpoint: breakpoint
    };
}


export function flickityDragEnd() {
    return {
        type: FLICKITY_DRAG_END,
        payload: { time: new Date().getTime() }
    };
}


// WEBPACK FOOTER //
// ./src/actions/content.js